import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Listens for postMessage from the service worker (notification deep links).
 * Falls back to window.location.href if React Router isn't available yet.
 */
export function useServiceWorkerMessages() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const handler = (event: MessageEvent) => {
      if (event.data?.type === "NAVIGATE" && event.data.url) {
        try {
          navigate(event.data.url);
        } catch {
          window.location.href = event.data.url;
        }
      }
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () => {
      navigator.serviceWorker.removeEventListener("message", handler);
    };
  }, [navigate]);
}
